(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-calculadora"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[id^="ch-calculadora-"]').forEach(function(wrap) {
      var id = wrap.id.replace('ch-calculadora-', '');
      var ADPROSURE = parseInt(wrap.dataset.adprosure) || 62000;
      var KIT = parseInt(wrap.dataset.kit) || 120000;
      var PRO = parseInt(wrap.dataset.pro) || 29990;

      var slider = document.getElementById('ch-calc-slider-' + id);
      var elPrice = document.getElementById('ch-price-' + id);
      var elMonthly = document.getElementById('ch-monthly-' + id);
      var elYear1 = document.getElementById('ch-year1-' + id);
      var elYear5 = document.getElementById('ch-year5-' + id);
      var card = document.getElementById('ch-calc-card-' + id);

      if (!slider) return;

      function fmt(n) {
        return '$' + Math.max(0, Math.round(n)).toLocaleString('es-CL').replace(/,/g, '.');
      }

      function update() {
        var price = parseInt(slider.value);
        var monthly = Math.max(0, price - PRO);
        var year1 = monthly * 12;
        var year5 = monthly * 60;

        var pct = ((price - parseInt(slider.min)) / (parseInt(slider.max) - parseInt(slider.min))) * 100;
        slider.style.setProperty('--rng', pct.toFixed(1) + '%');

        elPrice.textContent = fmt(price);
        elMonthly.textContent = fmt(monthly);
        elYear1.textContent = fmt(year1);
        elYear5.textContent = fmt(year5);

        if (card) card.classList.toggle('ch-calc--big', year5 > 500000);
      }

      slider.addEventListener('input', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-header-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('.ch-hv2');
    if (!header) return;

    var uid       = header.id.replace('ch-hv2-', '');
    var isHome    = header.dataset.isHome === 'true';
    var drawer    = document.querySelector('[data-drawer="' + uid + '"]');
    var hamburger = document.querySelector('[data-hamburger="' + uid + '"]');
    var backdrop  = document.querySelector('[data-backdrop="' + uid + '"]');

    /* --- Offset: reservar espacio bajo el header fijo --- */
    var main = document.querySelector('main');
    if (main) {
      main.classList.add('ch-hv2-offset');
      main.style.paddingTop = header.offsetHeight + 'px';
    }

    /* --- Scroll glass (home only) --- */
    function updateGlass() {
      header.classList.toggle('ch-hv2--scrolled', window.scrollY > 8);
    }

    if (isHome) {
      updateGlass();
      window.addEventListener('scroll', updateGlass, { passive: true });
    }

    /* --- Mobile drawer --- */
    if (!hamburger || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      if (backdrop) backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      if (backdrop) backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', function () {
      hamburger.getAttribute('aria-expanded') === 'true' ? closeDrawer() : openDrawer();
    });

    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* --- Call modal --- */
    function openCallModal(id) {
      var modal = document.getElementById('ch-call-modal-' + id);
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var firstInput = modal.querySelector('input, select');
      if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
    }

    function closeCallModal(id) {
      var modal = document.getElementById('ch-call-modal-' + id);
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-open-call]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openCallModal(btn.dataset.openCall);
      });
    });

    document.querySelectorAll('[data-close-call]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeCallModal(el.dataset.closeCall);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.ch-call-modal[aria-hidden="false"]').forEach(function (m) {
          closeCallModal(m.id.replace('ch-call-modal-', ''));
        });
      }
    });

    /* --- Floating call button (FAB) visibility --- */
    var fab = document.querySelector('.ch-fab');
    if (fab) {
      var fabThreshold = header.offsetHeight * 2;
      function updateFab() {
        fab.classList.toggle('is-visible', window.scrollY > fabThreshold);
      }
      updateFab();
      window.addEventListener('scroll', updateFab, { passive: true });
    }

    var callForm = document.querySelector('[data-call-form]');
    if (callForm) {
      callForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var firstname = callForm.querySelector('[name="firstname"]');
        var phone     = callForm.querySelector('[name="phone"]');
        if (!firstname.value.trim() || !phone.value.trim()) return;

        var btn = callForm.querySelector('.ch-call-modal__submit');
        if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }

        var horario = callForm.querySelector('[name="horario"]') ? callForm.querySelector('[name="horario"]').value : '';

        var _hsHutk = document.cookie.split(';').reduce(function (acc, c) {
          var p = c.trim().split('=');
          return p[0] === 'hubspotutk' ? decodeURIComponent(p[1]) : acc;
        }, '');
        var _hsPayload = {
          fields: [
            { name: 'firstname', value: firstname.value.trim() },
            { name: 'phone',     value: phone.value.trim() },
            { name: 'message',   value: 'Horario preferido: ' + horario }
          ],
          context: { pageUri: window.location.href, pageName: document.title }
        };
        if (_hsHutk) _hsPayload.context.hutk = _hsHutk;

        fetch('https://api.hsforms.com/submissions/v3/integration/submit/48318016/bc0bb7f1-a11b-448c-b801-e508b78b4890', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(_hsPayload)
        }).finally(function () {
          var _hsq = window._hsq = window._hsq || [];
          _hsq.push(['identify', { firstname: firstname.value.trim(), phone: phone.value.trim() }]);
          _hsq.push(['trackPageView']);

          var msg = callForm.querySelector('.ch-call-modal__success');
          if (msg) { msg.removeAttribute('hidden'); }
          callForm.querySelector('.ch-call-modal__submit') && (callForm.querySelector('.ch-call-modal__submit').style.display = 'none');
          setTimeout(function () {
            document.querySelectorAll('.ch-call-modal[aria-hidden="false"]').forEach(function (m) {
              closeCallModal(m.id.replace('ch-call-modal-', ''));
            });
            callForm.reset();
            if (msg) msg.setAttribute('hidden', '');
            if (btn) { btn.disabled = false; btn.style.display = ''; btn.textContent = 'Agendar llamado'; }
          }, 2800);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-kit-detalle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('ch-kdet-{{ section.id }}');
    if (!root) return;

    // Galería de miniaturas
    root.querySelectorAll('.ch-kdet__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = document.getElementById(btn.dataset.imgId);
        if (!img) return;
        img.src = btn.dataset.src;
        if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
        btn.closest('.ch-kdet__thumbs').querySelectorAll('.ch-kdet__thumb').forEach(function (b) {
          b.classList.remove('ch-kdet__thumb--active');
        });
        btn.classList.add('ch-kdet__thumb--active');
      });
    });

    // Selector de plan (tarjetas con radio)
    root.querySelectorAll('.ch-kdet__plan-card').forEach(function (card) {
      function selectCard(selected) {
        root.querySelectorAll('.ch-kdet__plan-card').forEach(function (c) {
          c.classList.remove('ch-kdet__plan-card--selected');
          c.setAttribute('aria-checked', 'false');
          var radio = c.querySelector('.ch-kdet__plan-radio');
          if (radio) radio.classList.remove('ch-kdet__plan-radio--active');
        });
        selected.classList.add('ch-kdet__plan-card--selected');
        selected.setAttribute('aria-checked', 'true');
        var radio = selected.querySelector('.ch-kdet__plan-radio');
        if (radio) radio.classList.add('ch-kdet__plan-radio--active');
      }
      card.addEventListener('click', function () { selectCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(card); }
      });
    });

    // Acordeón FAQ
    root.querySelectorAll('.ch-kdet__faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ch-kdet__faq-item');
        var answer = item.querySelector('.ch-kdet__faq-a');
        var isOpen = answer.classList.contains('ch-kdet__faq-a--open');

        root.querySelectorAll('.ch-kdet__faq-a').forEach(function (a) {
          a.classList.remove('ch-kdet__faq-a--open');
          a.previousElementSibling.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          answer.classList.add('ch-kdet__faq-a--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-kit-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('ch-kfaq-{{ section.id }}');
    if (!root) return;

    root.querySelectorAll('.ch-kfaq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.ch-kfaq__item');
        var answer = item.querySelector('.ch-kfaq__a');
        var isOpen = answer.classList.contains('ch-kfaq__a--open');

        root.querySelectorAll('.ch-kfaq__item').forEach(function (it) {
          it.querySelector('.ch-kfaq__a').classList.remove('ch-kfaq__a--open');
          it.querySelector('.ch-kfaq__q').setAttribute('aria-expanded', 'false');
          it.classList.remove('ch-kfaq__item--open');
        });

        if (!isOpen) {
          answer.classList.add('ch-kfaq__a--open');
          btn.setAttribute('aria-expanded', 'true');
          item.classList.add('ch-kfaq__item--open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-kit-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Ship date — fill every instance on page
    document.querySelectorAll('.ch-khero__ship-date').forEach(function (el) {
      var d = new Date();
      d.setDate(d.getDate() + 4);
      var months = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
      el.textContent = d.getDate() + ' de ' + months[d.getMonth()];
    });

    // Init each hero section independently via data attributes (no section.id in JS)
    document.querySelectorAll('.ch-khero').forEach(function (hero) {

      // Gallery — index-based navigation with arrows + thumbnails
      var mainImg    = hero.querySelector('.ch-khero__img');
      var thumbs     = Array.from(hero.querySelectorAll('.ch-khero__thumb'));
      var prevBtn    = hero.querySelector('[data-gallery-prev]');
      var nextBtn    = hero.querySelector('[data-gallery-next]');
      var currentIdx = 0;

      var galleryMain = hero.querySelector('[data-gallery-main]');

      function goToSlide(idx) {
        if (!thumbs.length || !mainImg) return;
        idx = (idx + thumbs.length) % thumbs.length;
        currentIdx = idx;
        var thumb = thumbs[idx];
        mainImg.style.opacity = '0.5';
        if (galleryMain) galleryMain.classList.add('ch-khero__gallery-main--loading');
        mainImg.src = thumb.dataset.src;
        if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
        function onDone() {
          mainImg.style.opacity = '';
          if (galleryMain) galleryMain.classList.remove('ch-khero__gallery-main--loading');
        }
        mainImg.onload = onDone;
        mainImg.onerror = onDone;
        thumbs.forEach(function (b) { b.classList.remove('ch-khero__thumb--active'); });
        thumb.classList.add('ch-khero__thumb--active');
        // scroll thumbnail into view within the strip only (not the page)
        var strip = thumb.closest('.ch-khero__thumbs');
        if (strip) {
          var center = thumb.offsetLeft - (strip.offsetWidth - thumb.offsetWidth) / 2;
          strip.scrollTo({ left: center, behavior: 'smooth' });
        }
      }

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          goToSlide(parseInt(btn.dataset.index, 10) || 0);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIdx + 1); });

      // Plan selector — scoped to this hero, no getElementById with section.id
      var planGroup      = hero.querySelector('[data-plan-group]');
      var variantInput   = hero.querySelector('[data-ch-variant-input]');
      var selectedPlanName = '';

      function selectPlan(card) {
        planGroup.querySelectorAll('.ch-khero__plan-card').forEach(function (c) {
          c.classList.remove('ch-khero__plan-card--sel');
          c.setAttribute('aria-checked', 'false');
          var r = c.querySelector('.ch-khero__plan-radio');
          if (r) r.classList.remove('ch-khero__plan-radio--on');
        });
        card.classList.add('ch-khero__plan-card--sel');
        card.setAttribute('aria-checked', 'true');
        var r = card.querySelector('.ch-khero__plan-radio');
        if (r) r.classList.add('ch-khero__plan-radio--on');
        if (variantInput && card.dataset.variantId) {
          variantInput.value = card.dataset.variantId;
        }
        selectedPlanName = card.dataset.planName || '';
      }

      if (planGroup) {
        var defaultCard = planGroup.querySelector('.ch-khero__plan-card--sel');
        if (defaultCard) selectedPlanName = defaultCard.dataset.planName || '';

        planGroup.addEventListener('click', function (e) {
          var card = e.target.closest('.ch-khero__plan-card');
          if (card && planGroup.contains(card)) selectPlan(card);
        });
        planGroup.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var card = e.target.closest('.ch-khero__plan-card');
          if (card && planGroup.contains(card)) { e.preventDefault(); selectPlan(card); }
        });
      }

      // Buy form → add to cart then redirect to checkout
      var buyForm = hero.querySelector('[data-ch-buy-form]');
      if (buyForm) {
        buyForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var id  = parseInt((variantInput && variantInput.value) || 0);
          var btn = buyForm.querySelector('[type="submit"]');
          if (!id) { window.location.href = '/cart'; return; }
          if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; }
          var cartProps = {};
          if (selectedPlanName) cartProps['_Plan elegido'] = selectedPlanName;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1, properties: cartProps })
          }).then(function () {
            window.location.href = '/checkout';
          }).catch(function () {
            if (btn) { btn.disabled = false; btn.style.opacity = ''; }
            window.location.href = '/cart';
          });
        });
      }

      // "Necesito personalizarlo" → add kit to cart silently + scroll to carousel
      var customizeBtn = hero.querySelector('[data-ch-customize]');
      if (customizeBtn) {
        customizeBtn.addEventListener('click', function () {
          var id = parseInt((variantInput && variantInput.value) || 0);

          // 1. Scroll immediately — user sees the carousel without waiting for the network
          var target = document.querySelector('.ch-kit-alts');
          if (target) {
            var headerEl = document.querySelector('.header-section');
            var offset = headerEl ? headerEl.offsetHeight : 0;
            var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }

          // 2. Add to cart silently in the background
          if (!id) return;
          var customizeProps = {};
          if (selectedPlanName) customizeProps['_Plan elegido'] = selectedPlanName;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1, properties: customizeProps })
          })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { itemCount: 1, source: 'product-form-component' } }
            }));
            if (window.CHCart) window.CHCart.refresh();
          })
          .catch(function () {});
        });
      }

    });

    // Move modals to <body> to avoid stacking context conflicts with sticky header
    document.querySelectorAll('.ch-expert-modal').forEach(function (modal) {
      document.body.appendChild(modal);
    });

    // Expert modal
    document.querySelectorAll('[data-open-expert]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.getElementById('ch-expert-modal-' + btn.dataset.openExpert);
        if (!modal) return;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var first = modal.querySelector('input, select, button');
        if (first) first.focus();
      });
    });

    function closeExpertModal(id) {
      var modal = document.getElementById('ch-expert-modal-' + id);
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-close-expert]').forEach(function (el) {
      el.addEventListener('click', function () { closeExpertModal(el.dataset.closeExpert); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.ch-expert-modal[aria-hidden="false"]').forEach(function (m) {
        closeExpertModal(m.id.replace('ch-expert-modal-', ''));
      });
    });

    document.querySelectorAll('[data-expert-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var firstname = form.querySelector('[name="firstname"]').value.trim();
        var phone     = form.querySelector('[name="phone"]').value.trim();
        var horario   = form.querySelector('[name="horario"]').value;
        if (!firstname || !phone) return;
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; }
        var _hsHutk = document.cookie.split(';').reduce(function (acc, c) {
          var p = c.trim().split('=');
          return p[0] === 'hubspotutk' ? decodeURIComponent(p[1]) : acc;
        }, '');
        var _hsPayload = {
          fields: [
            { name: 'firstname', value: firstname },
            { name: 'phone',     value: phone },
            { name: 'message',   value: 'Horario preferido: ' + horario + ' | Fuente: formulario experto' }
          ],
          context: { pageUri: window.location.href, pageName: document.title }
        };
        if (_hsHutk) _hsPayload.context.hutk = _hsHutk;

        fetch('https://api.hsforms.com/submissions/v3/integration/submit/48318016/bc0bb7f1-a11b-448c-b801-e508b78b4890', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(_hsPayload)
        }).finally(function () {
          var _hsq = window._hsq = window._hsq || [];
          _hsq.push(['identify', { firstname: firstname, phone: phone }]);
          _hsq.push(['trackPageView']);

          form.reset();
          if (btn) { btn.disabled = false; btn.style.opacity = ''; }
          var msg = form.querySelector('.ch-expert-modal__success');
          if (msg) { msg.hidden = false; }
          setTimeout(function () {
            document.querySelectorAll('.ch-expert-modal[aria-hidden="false"]').forEach(function (m) {
              closeExpertModal(m.id.replace('ch-expert-modal-', ''));
            });
          }, 2500);
        });
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-landing-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-testimoniales"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestiScrollers() {
      document.querySelectorAll('[data-testi-track]').forEach(function (track) {
        if (track.dataset.testiInit) return;
        track.dataset.testiInit = '1';
        track.innerHTML += track.innerHTML;
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTestiScrollers);
    } else {
      initTestiScrollers();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.getElementById('header-component');
  if (header && header.hasAttribute('data-scroll-blur')) {
    const update = () => {
      header.toggleAttribute('data-at-top', window.scrollY < 50);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
